export default "__VITE_ASSET__6mpNvPmZ__"